/*vue2
import { defineComponent } from "vue";

export default defineComponent({
  // dialog open/close methods
  name: "dialog-mixin",

  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    open: {
      get(): boolean {
        return this.isOpen;
      },
      set(value: boolean) {
        this.$emit("is-open", value);
      },
    },
  },
  methods: {
    close() {
      this.$emit("is-open", false);
    },
  },
});
*/

//vue3
import { defineComponent } from "vue";

export default defineComponent({
  name: "dialog-mixin",

  // Vue 3では emits を明示すると型推論と警告の精度が上がります（オプションですが推奨）
  emits: ["is-open"],

  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    open: {
      get(): boolean {
        return this.isOpen;
      },
      set(value: boolean) {
        this.$emit("is-open", value);
      },
    },
  },
  methods: {
    close() {
      this.$emit("is-open", false);
    },
  },
});
